import { InfoCard } from "../common/InfoCard"
import { LabelRow } from "../common/LabelRow"
import { LabelWithUnitRow } from "../common/LabelWithUnitRow"
import { ManualInputRow } from "../common/ManualInputRow"
import { StreamName } from "../common/StreamName"
import { UnitProps } from "../unitTypes"
import { TableCard } from "./TableCard"
import { TableCardStream2 } from "./TableCardStream2"

interface ExchangerMainTabProps extends UnitProps {
  onChange: (changes) => void
  onBPChange: (changes, stream: 1 | 2) => void
}

export function ExchangerMainTab(props: ExchangerMainTabProps) {
  const {unit, data, onChange, onBPChange} = props
  const varsData = data?.vars || {}
  const unitData = varsData.UNIT || {}
  
  return <div>
    <LabelRow label="Stream1 Inlet" value={<StreamName unitId={varsData.S1_IN?.unitId}/>}/>
    <LabelRow label="Stream1 Outlet" value={<StreamName unitId={varsData.S1_OUT?.unitId}/>}/>
    <LabelRow label="Stream2 Inlet" value={<StreamName unitId={varsData.S2_IN?.unitId}/>}/>
    <LabelRow label="Stream2 Outlet" value={<StreamName unitId={varsData.S2_OUT?.unitId}/>}/>
    {unitData.Q !== undefined && <LabelWithUnitRow label="Duty" value={unitData.Q} dimCode="HEATFLOW"/>}
    {!!unitData.Q_LOSS && <LabelWithUnitRow label="Duty Losses" value={unitData.Q_LOSS} dimCode="HEATFLOW"/>}
    <TableCard onBPChange={(changes) => onBPChange(changes, 1)} data={data} storageKey={'STREAM1_TABLE'} unit={unit} onChange={onChange} cardClassName="mt-1" />
    <TableCardStream2 onBPChange={(changes) => onBPChange(changes, 2)} data={data} unit={unit} cardClassName="mt-1" />
    <InfoCard title="Pressure Drop" className="mt-1">
      <ManualInputRow label="Stream1" dimCode='DPRES' data={unitData?.S1_DP} attrKey=":STR1:UNIT:DP" unitId={unit.id}/>
      <ManualInputRow label="Stream2" dimCode='DPRES' data={unitData?.S2_DP} attrKey=":STR2:UNIT:DP" unitId={unit.id}/>
    </InfoCard>
  </div>
}